import { UPGRADE_BANNER_TYPES } from '../../ums/types';
import getUpgradeBannerTranslations from './getUpgradeBannerTranslations';
export const validateUpgradePointType = upgradeConfig => {
  if (!Object.keys(UPGRADE_BANNER_TYPES).includes(upgradeConfig.pointType.toString())) {
    throw new Error('Validation error - incompatible point type', {
      cause: `${upgradeConfig.upgradeKey}: is declared with an incompatible point type "${upgradeConfig.pointType.toString()}"`
    });
  }
};
export const validateUpgradeBannerDescriptions = upgradeConfig => {
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradeConfig.content);
  if (!bannerTitle) {
    throw new Error('Validation error - missing HEADING_SHORT', {
      cause: `${upgradeConfig.upgradeKey}: is missing HEADING_SHORT`
    });
  }
  if (!bannerSubtitle) {
    throw new Error('Validation error - missing BODY_SHORT', {
      cause: `${upgradeConfig.upgradeKey}: is missing BODY_SHORT`
    });
  }
};